import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateRangePickerComponent } from './date-range-picker.component';
import { FormsModule } from '@angular/forms';
import { CalendarRangeModule } from '../calendar-range/calendar-range.module';
import { InputModule } from '../input/input.module';
import { DateRangePickerDemoComponent } from './date-range-picker.demo.component';
import { TooltipModule } from '../tooltip/tooltip.module';

@NgModule({
  declarations: [DateRangePickerComponent, DateRangePickerDemoComponent],
  imports: [CommonModule, FormsModule, CalendarRangeModule, InputModule, TooltipModule],
  exports: [DateRangePickerComponent, DateRangePickerDemoComponent],
})
export class DateRangePickerModule {}
